import { render, staticRenderFns } from "./tech-card.vue?vue&type=template&id=9f90b30a&scoped=true"
import script from "./tech-card.ts?vue&type=script&lang=ts&external"
export * from "./tech-card.ts?vue&type=script&lang=ts&external"
import style0 from "./tech-card.vue?vue&type=style&index=0&id=9f90b30a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f90b30a",
  null
  
)

export default component.exports